/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendQuoteToErpResponse
 */
export interface SendQuoteToErpResponse {
    /**
     * 
     * @type {string}
     * @memberof SendQuoteToErpResponse
     */
    redirectionUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendQuoteToErpResponse
     */
    forwardInNewTab: boolean;
}

/**
 * Check if a given object implements the SendQuoteToErpResponse interface.
 */
export function instanceOfSendQuoteToErpResponse(value: object): value is SendQuoteToErpResponse {
    if (!('redirectionUrl' in value) || value['redirectionUrl'] === undefined) return false;
    if (!('forwardInNewTab' in value) || value['forwardInNewTab'] === undefined) return false;
    return true;
}

export function SendQuoteToErpResponseFromJSON(json: any): SendQuoteToErpResponse {
    return SendQuoteToErpResponseFromJSONTyped(json, false);
}

export function SendQuoteToErpResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendQuoteToErpResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectionUrl': json['redirectionUrl'],
        'forwardInNewTab': json['forwardInNewTab'],
    };
}

export function SendQuoteToErpResponseToJSON(value?: SendQuoteToErpResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'redirectionUrl': value['redirectionUrl'],
        'forwardInNewTab': value['forwardInNewTab'],
    };
}

